"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MenuTab = exports.MenuItem = exports.Menu = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Menu = _styledComponents["default"].div.withConfig({
  displayName: "styles__Menu"
})(["font-family:sans-serif;font-weight:300;", ";", ";", ";"], function (a) {
  return 0 === a.level && "\n      position: relative;\n      display: flex;\n    ";
}, function (a) {
  return 1 === a.level && "\n      position: absolute;\n      top: 45px;\n      left: 0;\n      display: none;\n      flex-direction: column;\n  ";
}, function (a) {
  return 2 === a.level && "\n      display: none;\n      flex-direction: column;\n      position: absolute;\n      top: 0;\n      left: 100%;\n  ";
});

exports.Menu = Menu;

var MenuItem = _styledComponents["default"].div.withConfig({
  displayName: "styles__MenuItem"
})(["height:45px;position:relative;padding:0 1rem;cursor:pointer;z-index:11;", ";", ";", ";&:hover{", ";", ";", ";transition:0.2s linear;> .sub{display:flex;}}a{color:white;text-decoration:none;height:100%;display:flex;align-items:center;&:hover{color:white;}}"], function (a) {
  return 0 === a.level && "\n    background-color: #0a4f7a;\n  ";
}, function (a) {
  return 1 === a.level && "\n    background-color: #086391;\n    min-width: 200px;\n  ";
}, function (a) {
  return 2 === a.level && "\n    background-color: #008db0;\n    min-width: 150px;\n  ";
}, function (a) {
  return 0 === a.level && "\n      background-color: #086391;\n    ";
}, function (a) {
  return 1 === a.level && "\n      background-color: #008db0;\n    ";
}, function (a) {
  return 2 === a.level && "\n      background-color: #1ea5c7;\n    ";
});

exports.MenuItem = MenuItem;

var MenuTab = _styledComponents["default"].a.withConfig({
  displayName: "styles__MenuTab"
})([""]);

exports.MenuTab = MenuTab;